<template>
  <div v-if="person.id && isGraph()" class="switcher">
    <div class="switcher-link" @click="updateCategory(all)">
      <span v-if="category === all" class="switcher-link-icon">
        <img src="/static/rating.svg"/>
      </span>
      <router-link :to="link(all)" :class="['switcher-link-a', {'switcher-link-a-active': all === category}]">Все</router-link>
    </div>
    <div v-for="cat in tags" class="switcher-link" @click="updateCategory(cat.tag)">
      <span v-if="cat.tag === category" class="switcher-link-icon">
        <img src="/static/rating.svg"/>
      </span>
      <router-link :to="link(cat.tag)" :class="['switcher-link-a', {'switcher-link-a-active': cat.tag === category}]">{{ cat.name }}</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    personIsAdmin: 'personIsAdmin',
    person: 'personCurrent',
    fancyList: 'fancyList',
    category: 'category',
    persons: 'persons',
    theme: 'theme',
    tags: 'tags',
  }),

  data() {
    return {
      all: 'all',
    };
  },

  watch: {
    $route() {
      if (this.$route.fullPath === '/') {
        this.updateCategory('all');
      }
    },
  },

  mounted() {
    let slug = 'all';
    if (this.$route.params.tag) slug = this.$route.params.tag;
    if (!this.$route.params.user) this.updateCategory(slug);
  },

  methods: {
    updateCategory(slug) {
      this.$store.commit('SET_CATEGORY', slug);
      this.$store.dispatch('fetchPersonsWithNewTag', null);
    },

    isGraph() {
      const pages = ['Greeting', 'Statistic'];
      return pages.includes(this.$route.name);
    },

    link(slug) {
      let link = '/';
      if (slug !== '') {
        link = `/${slug}/`;
      }
      return link;
    },
  },
};
</script>

<style>
@keyframes showRating{
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}

.switcher{
  @media (min-width: $mediaIpad) {
    text-align: center;
    width: 100%;
  }

  @media (max-width: $mediaMob) {
    display: none;
  }

  &-link{
    display: inline-block;
    vertical-align: top;
    margin-right: 27px;
    position: relative;

    &:last-child{
      margin-right: 0;
    }

    &-icon{
      animation: showRating .3s ease-in-out;
      position: absolute;
      left: -13px;
      top: -2px;

      img {
        width: 11px;
      }
    }

    &-a{
      border-bottom-style: dotted;
      color: #4a4a4a;
      font-size: 90%;

      &:active,
      &:focus,
      &:hover{
        color: #1abd19;
      }

      &-active {
        font-weight: bold;
        color: #1abd19;
        border: 0;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Switcher.vue?53f09917